// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "rgba(0, 0, 0, 0.85)",
	"menuActiveText": "#1890FF",
	"subMenuActiveText": "#1890FF",
	"menuBg": "#FFFFFF",
	"menuHover": "#fff",
	"subMenuBg": "#FAFAFA",
	"subMenuHover": "#E6F7FF",
	"sideBarWidth": "256px"
};
module.exports = exports;
